import axios from "axios";
import { ENDPOINTS } from "./endpoints";

export const getSurveyFolders = async (params = {}) => {
  try {
    const response = await axios.get(ENDPOINTS.SURVEY_FOLDER.GET, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createSurveyFolder = async (data) => {
  try {
    const response = await axios.post(ENDPOINTS.SURVEY_FOLDER.CREATE, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSurveyFolderById = async (id) => {
  try {
    const response = await axios.get(`${ENDPOINTS.SURVEY_FOLDER.GET_FOLDER}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateSurveyFolder = async (id, data) => {
  try {
    const response = await axios.put(`${ENDPOINTS.SURVEY_FOLDER.UPDATE}/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteSurveyFolder = async (id) => {
  try {
    const response = await axios.delete(`${ENDPOINTS.SURVEY_FOLDER.DELETE}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOpenSurveysInFolder = async (id, params = {}) => {
  try {
    const response = await axios.get(`${ENDPOINTS.SURVEY_FOLDER.GET_FOLDER}/${id}/${ENDPOINTS.SURVEY_FOLDER.FOLDER_SURVEYS}`, { params });
    return response;
  } catch (error) {
    throw error;
  }
};
